(() => {
  'use strict';
  if (window.tnmCaseShipping) return;
  const element = document.getElementById('tnm-case-shipping-config');
  if (!element) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch { return; }
  if (!Array.isArray(config.variants) || !config.variants.length || config.variants.some(id => !Number.isSafeInteger(id) || id < 1) ||
      typeof config.code !== 'string' || !Number.isSafeInteger(config.minimum) || !Number.isSafeInteger(config.automaticMinimum) ||
      config.automaticMinimum <= config.minimum || !/^\/(?:[^?#]*\/)?$/.test(config.root)) return;
  // The verified native $199+ automatic discount already supplies free shipping.
  // Applying a second shipping code there produces a misleading checkout warning.
  const qualified = cart => cart.currency === config.currency && cart.items.some(item => config.variants.includes(Number(item.variant_id)) && !item.selling_plan_allocation) && cart.total_price >= config.minimum && cart.total_price < config.automaticMinimum;
  const codes = cart => (cart.discount_codes || []).map(discount => discount.code);
  const snapshot = cart => JSON.stringify(cart.items.map(item => [item.key, item.variant_id, item.quantity, item.selling_plan_allocation || null, item.properties || {}]));
  let pending = null;
  const reconcile = async cart => {
    if (!Array.isArray(cart?.items) || !Number.isSafeInteger(cart.total_price)) throw new Error('shipping_cart_unreadable');
    const active = qualified(cart);
    const hasCode = codes(cart).some(code => code.toUpperCase() === config.code);
    if (active === hasCode) {
      if (active && !cart.discount_codes.some(discount => discount.code.toUpperCase() === config.code && discount.applicable === true)) throw new Error('shipping_discount_unavailable');
      return cart;
    }
    const wanted = codes(cart).filter(code => code.toUpperCase() !== config.code);
    if (active) wanted.push(config.code);
    // A lost response is resolved by a fresh read, never by repeating the write.
    try {
      const response = await window.fetch(config.root + 'cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:wanted.join(',')})});
      if (!response.ok) throw new Error('shipping_discount_rejected');
    } catch { /* Verify persistence below. */ }
    const response = await window.fetch(config.root + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('shipping_cart_unavailable');
    const after = await response.json();
    if (!Array.isArray(after.items) || after.currency !== cart.currency || snapshot(after) !== snapshot(cart) ||
        !wanted.every(code => codes(after).some(saved => saved.toUpperCase() === code.toUpperCase())) ||
        (!active && codes(after).some(code => code.toUpperCase() === config.code)) ||
        (active && !after.discount_codes?.some(discount => discount.code.toUpperCase() === config.code && discount.applicable === true))) throw new Error('shipping_discount_unverified');
    return after;
  };
  // The tnm20/ck lander widgets await this ensure() and then navigate to
  // checkout programmatically (location.assign), which the free-gift guard's
  // click/submit interceptors never see. Chain the gift reconcile after the
  // shipping reconcile so promised gift lines are in the cart before that
  // navigation. Fail OPEN: any gift failure still returns the shipping cart
  // so checkout proceeds exactly as the page's own handler intends.
  // The gift wait is capped: a slow or hung cart request must never hold the
  // shopper's checkout tap. Past the cap the shipping cart stands (fail open).
  const GIFT_WAIT_MS = 3000;
  const withGift = async cart => {
    const after = await reconcile(cart);
    try {
      const gift = await Promise.race([
        window.tnmFreeMeatGift?.ensure(),
        new Promise(resolve => setTimeout(() => resolve(null), GIFT_WAIT_MS)),
      ]);
      if (gift && gift.cart) return gift.cart;
    } catch { /* Gift guard unavailable: shipping result stands. */ }
    return after;
  };
  window.tnmCaseShipping = {ensure: cart => {
    const run = (pending || Promise.resolve()).then(() => withGift(cart));
    pending = run.catch(() => {}).finally(() => { if (pending === tail) pending = null; });
    const tail = pending;
    return run;
  }};
})();
